import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

import { Provider } from 'react-redux';
import {store} from './store'

import global_en from './translations/en/global.json' 
import global_ar from './translations/ar/global.json' 
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from './context/ThemeContext';

const normalizeLang = (value) => (String(value || '').toLowerCase().startsWith('ar') ? 'ar' : 'en');
const applyDocumentLang = (langCode) => {
  const normalized = normalizeLang(langCode);
  document.documentElement.lang = normalized;
  document.documentElement.dir = normalized === 'ar' ? 'rtl' : 'ltr';
  return normalized;
};

i18next.init({
  interpolation:{ escapeValue: false},
  lng:(() => {
    try {
      const stored = localStorage.getItem('preferredLang') || localStorage.getItem('i18nextLng') || localStorage.getItem('appLang') || 'ar';
      return applyDocumentLang(stored);
    } catch {
      return applyDocumentLang('ar');
    }
  })(),
  resources:{
    en:{
      global:global_en,
    },
    ar:{
      global:global_ar,
    },
  }
});

i18next.on('languageChanged', (lng) => {
  applyDocumentLang(lng);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <I18nextProvider i18n={i18next}>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </I18nextProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
